import { useState, useEffect } from "react";
import { getUnreadCountWithoutCallNotes } from "src/scenes/Chat/utils/unreadNotifications";
/**
 * @typedef {import('matrix-js-sdk').MatrixClient} MatrixClient
 * @param {MatrixClient} matrixClient
 * @param activeChatLists Array
 */
export const useChatListUnread = (matrixClient, activeChatLists) => {
    const [activeChatsTotalUnread, setActiveChatsTotalUnread] = useState([]);
    const matrixRooms = matrixClient?.store?.rooms || null;
    useEffect(() => {
        const initialize = () => {
            try {
                const chatListsUnread = () => {
                    return activeChatLists.map((activeChatList) => {
                        return {
                            label: activeChatList.label,
                            totalUnreadCount: 0
                        };
                    });
                };

                const unread = chatListsUnread();
                setActiveChatsTotalUnread(unread);
            } catch {
                return console.warn("Failed to initialize Chat List unread.");
            }
        };

        initialize();
    }, [activeChatLists, matrixRooms]);

    const updateActiveChatListTotalUnread = () => {
        const rooms = matrixClient?.store?.rooms;
        if (!rooms) {
            return;
        }
        setActiveChatsTotalUnread(prevActiveChatsTotalUnread => {
            const updatedActiveChatsTotalUnread = prevActiveChatsTotalUnread.map(chat => ({ ...chat, totalUnreadCount: 0 }));

            for (const roomId of Object.keys(rooms)) {
                const room = matrixClient.getRoom(roomId);
                if (!room) {
                    continue;
                }
                const totalUnreadFromSync = getUnreadCountWithoutCallNotes(
                    room,
                    matrixClient.getUserId?.() || ""
                );
                const chatListLabel = findChatListByMatrixRoomId(roomId);
    
                if (chatListLabel) {
                    const chatListIndex = updatedActiveChatsTotalUnread.findIndex(chatList => chatList.label === chatListLabel);
                    if (chatListIndex !== -1) {
                        updatedActiveChatsTotalUnread[chatListIndex].totalUnreadCount += totalUnreadFromSync;
                    }
                }
            }
    
            return updatedActiveChatsTotalUnread;
        });
    };

    const findChatListByMatrixRoomId = (matrixRoomId) => {
        if (!activeChatLists || !matrixRoomId) {
            console.warn("Empty chat list or roomId", activeChatLists, matrixRoomId);
            return null;
        }
        // Iterate through each object in the data
        for (const chatList of Object.values(activeChatLists)) {
            // Check if the object has a "data.chats" property
            if (chatList.data && chatList.data.chats) {
                // Search for the chat with matching matrixRoomId
                const matchingChat = chatList.data.chats.find(chat => chat.matrixRoomId === matrixRoomId);
                //console.warn("matchingChat", matchingChat, chatList.data.chats, matrixRoomId, chatList.label);
                if (matchingChat) {
                    return chatList.label; // Return the chatList's label if a match is found
                }
            }
        }
        return null; // Return null if no matching chatList is found
    };

    return {
        updateActiveChatListTotalUnread,
        activeChatsTotalUnread
    };
};
